import script from "./StripeElementCardPay.vue?vue&type=script&setup=true&lang=ts"
export * from "./StripeElementCardPay.vue?vue&type=script&setup=true&lang=ts"

import "./StripeElementCardPay.vue?vue&type=style&index=0&id=70cb4344&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70cb4344"]])

export default __exports__